import mermaid from "mermaid";
import { createElement, Fragment, useEffect, useMemo, useState } from "react";
import * as production from "react/jsx-runtime";
import rehypeHighlight from "rehype-highlight";
import rehypeReact from "rehype-react";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import { unified } from "unified";
import { Dialog } from "tamagui";
import { Fragment as Fragment2, jsx } from "react/jsx-runtime";
const MarkdownComponent = ({
  children
}) => {
  return useMarkdownProcessor(children);
};
const useMarkdownProcessor = content => {
  useEffect(() => {
    mermaid.initialize({
      startOnLoad: false,
      theme: "forest",
      suppressErrorRendering: true
      // Prevents Mermaid from injecting error elements into the DOM
    });
  }, []);
  return useMemo(() => {
    return unified().use(remarkParse).use(remarkGfm).use(remarkRehype).use(rehypeHighlight, {
      ignoreMissing: true
    }).use(rehypeReact, {
      ...production,
      createElement,
      Fragment,
      components: {
        a: ({
          href,
          children
        }) => /* @__PURE__ */jsx("a", {
          href,
          target: "_blank",
          rel: "noreferrer",
          className: "...",
          children
        }),
        h1: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h1", {
          className: "...",
          id,
          children
        }),
        h2: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h2", {
          className: "...",
          id,
          children
        }),
        h3: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h3", {
          className: "...",
          id,
          children
        }),
        h4: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h4", {
          className: "...",
          id,
          children
        }),
        h5: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h5", {
          className: "...",
          id,
          children
        }),
        h6: ({
          children,
          id
        }) => /* @__PURE__ */jsx("h6", {
          className: "...",
          id,
          children
        }),
        p: ({
          children
        }) => {
          return /* @__PURE__ */jsx("p", {
            className: "...",
            children
          });
        },
        strong: ({
          children
        }) => /* @__PURE__ */jsx("strong", {
          className: "...",
          children
        }),
        em: ({
          children
        }) => /* @__PURE__ */jsx("em", {
          children
        }),
        code: CodeBlock,
        pre: ({
          children
        }) => {
          return /* @__PURE__ */jsx("div", {
            className: "...",
            children: /* @__PURE__ */jsx("pre", {
              className: "...",
              children
            })
          });
        },
        ul: ({
          children
        }) => /* @__PURE__ */jsx("ul", {
          className: "...",
          children
        }),
        ol: ({
          children
        }) => /* @__PURE__ */jsx("ol", {
          className: "...",
          children
        }),
        li: ({
          children
        }) => /* @__PURE__ */jsx("li", {
          className: "...",
          children
        }),
        table: ({
          children
        }) => /* @__PURE__ */jsx("div", {
          className: "...",
          children: /* @__PURE__ */jsx("table", {
            className: "...",
            children
          })
        }),
        thead: ({
          children
        }) => /* @__PURE__ */jsx("thead", {
          className: "...",
          children
        }),
        th: ({
          children
        }) => /* @__PURE__ */jsx("th", {
          className: "...",
          children
        }),
        td: ({
          children
        }) => /* @__PURE__ */jsx("td", {
          className: "...",
          children
        }),
        blockquote: ({
          children
        }) => /* @__PURE__ */jsx("blockquote", {
          className: "...",
          children
        })
      }
    }).processSync(content).result;
  }, [content]);
};
const CodeBlock = ({
  children,
  className
}) => {
  const [showMermaidPreview, setShowMermaidPreview] = useState(false);
  if (className) {
    const isMermaid = className.includes("language-mermaid");
    return /* @__PURE__ */jsx(Fragment2, {
      children: /* @__PURE__ */jsx("div", {
        className: "...",
        children: isMermaid ? /* @__PURE__ */jsx(Fragment2, {
          children: /* @__PURE__ */jsx(Dialog, {
            open: showMermaidPreview,
            onOpenChange: setShowMermaidPreview,
            children: /* @__PURE__ */jsx(Mermaid, {
              content: children?.toString() ?? ""
            })
          })
        }) : null
      })
    });
  }
  return /* @__PURE__ */jsx("code", {
    className: "...",
    children
  });
};
const Mermaid = ({
  content
}) => {
  const [diagram, setDiagram] = useState(true);
  useEffect(() => {
    const render = async () => {
      const id = `mermaid-svg-${Math.round(Math.random() * 1e7)}`;
      const cleanContent = (content?.toString() ?? "").replace(/\u00A0/g, " ").replace(/&nbsp;/g, " ").replace(/class\s+.*_task/g, match => match.replace(/_task/g, "")).trim();
      try {
        if (await mermaid.parse(cleanContent, {
          suppressErrors: true
        })) {
          const {
            svg
          } = await mermaid.render(id, cleanContent);
          setDiagram(svg);
        } else {
          setDiagram(false);
        }
      } catch (error) {
        console.error("Mermaid Render Error:", error);
        const errNode = document.getElementById(id) || document.getElementById(`d${id}`);
        if (errNode) {
          errNode.remove();
        }
        setDiagram(false);
      }
    };
    render();
  }, [content]);
  if (diagram === true) {
    return /* @__PURE__ */jsx("p", {
      className: "...",
      children: "Rendering diagram..."
    });
  } else if (diagram === false) {
    return /* @__PURE__ */jsx("p", {
      className: "...",
      children: "Unable to render this diagram."
    });
  } else {
    return /* @__PURE__ */jsx("div", {
      dangerouslySetInnerHTML: {
        __html: diagram ?? ""
      }
    });
  }
};
export { MarkdownComponent, useMarkdownProcessor };
//# sourceMappingURL=Markdown.mjs.map
